import { VisualRunRateType } from '@snap-types/models/visual/operation/enums';
import { z } from 'zod/v4';

import { columns } from './columns';

export const visualServiceSchema = z.object(columns);

export type VisualService = z.output<typeof visualServiceSchema>;

export const visualServiceSelect = [
  'id',
  'description',
  'vendor_id',
  'run',
  'run_type',
] as const satisfies readonly (keyof VisualService)[];

export type VisualServiceQueryRecord = Pick<
  VisualService,
  (typeof visualServiceSelect)[number]
>;

export const visualConfiguratorServiceSchema = z.object({
  id: z.string().transform((s) => s.toUpperCase()),
  description: z
    .string()
    .nullable()
    .transform((s) => s?.toUpperCase() ?? null),
  run: z.number().nullable(),
  run_type: z
    .string()
    .nullable()
    .transform((v) => (v ? v.trim() : null))
    .pipe(z.enum(VisualRunRateType))
    .nullable(),
  vendor_id: z
    .string()
    .nullable()
    .transform((s) => s?.toUpperCase() ?? null),
}) satisfies z.ZodType<VisualServiceQueryRecord>;

export type VisualConfiguratorService = z.output<
  typeof visualConfiguratorServiceSchema
>;
